import { BaseApiModel } from "@/model/common/BaseApiModel";

export class Material extends BaseApiModel {
    name: string;
    note: string;
}